import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import CmsContentPage from "../components/CmsContentPage/CmsContentPage";

type Props = {
  history: any;
  intl: any;
};

const Funding: React.FC<Props> = ({ history, intl }) => {
  return (
    <CmsContentPage
      history={history}
      intl={intl}
      screenName="funding"
      headerMessageId="helpandlearning-faqs-funding"
    />
  );
};

export default connect(null, null)(injectIntl(Funding)) as any;
